export const urlRegex =
  // eslint-disable-next-line max-len
  /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-zA-Z0-9]+([-.]{1}[a-z0-9]+)*\.[a-zA-Z]{2,5}(:[0-9]{1,5})?(\/.*)?$/

export const formatPhoneNumber = (phone) => phone.replace(/\D/g, '');

export const isPhoneNumber = /\d/;